import { DetailOverlay, Label, ItemEditorBar } from "@/design/primitives";
import { WatchHeading, StateMessage } from "./WatchTile";

export const DETAIL_HEADINGS = ["What this watch does", "Why it exists", "When it last failed", "What Kit is doing about it"];

export const TileDetail = ({ item, variant = "desktop", onClose, editor }) => {
  const { does, why, lastFailed, kit } = item.detail;
  const bodies = [does, why, lastFailed, kit];
  return (
    <DetailOverlay variant={variant === "desktop" ? "panel" : "sheet"} onClose={onClose} label={`${item.name} details`} testId="tile-detail">
      <WatchHeading name={item.name} brand={item.brand} state={item.state} as="h2" className="pr-12 pt-2" />
      <StateMessage state={item.state} line={item.line} className="mt-4" />
      <div className="mt-6 border-t border-os-border">
        {DETAIL_HEADINGS.map((heading, i) => (
          <section key={heading} data-testid={`tile-detail-section-${i + 1}`} className="border-b border-os-border py-4">
            <Label as="h3">{heading}</Label>
            <p className="mt-1.5 text-[0.9375rem] leading-[1.55] text-os-ink">{bodies[i]}</p>
          </section>
        ))}
      </div>
      {editor && (
        <ItemEditorBar
          board={editor.board}
          item={editor.item}
          onClose={onClose}
          testId={`item-editor-tile-${item.slug}`}
        />
      )}
    </DetailOverlay>
  );
};
